import Api from 'utils/api'

export const fetchCandidates = ({
  id,
  query,
}: {
  id: number | string
  query: string
}) => Api.get(['candidates', id], query)
